module.exports = __webpack_public_path__ + "img/car-icon.f2f2dc69.png";